import { render, staticRenderFns } from "./PayeeSelector.vue?vue&type=template&id=24264a4e&scoped=true"
import script from "./PayeeSelector.vue?vue&type=script&lang=ts"
export * from "./PayeeSelector.vue?vue&type=script&lang=ts"
import style0 from "./PayeeSelector.vue?vue&type=style&index=0&id=24264a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24264a4e",
  null
  
)

export default component.exports